function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49984 0.5C1.0396 0.5 0.666504 0.873096 0.666504 1.33333C0.666504 1.79357 1.0396 2.16667 1.49984 2.16667H16.4998C16.9601 2.16667 17.3332 1.79357 17.3332 1.33333C17.3332 0.873096 16.9601 0.5 16.4998 0.5H1.49984Z",
  fill: "#BFBBCF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33317 5.5C7.33317 5.03976 7.70627 4.66667 8.1665 4.66667H16.4998C16.9601 4.66667 17.3332 5.03976 17.3332 5.5C17.3332 5.96024 16.9601 6.33333 16.4998 6.33333H8.1665C7.70627 6.33333 7.33317 5.96024 7.33317 5.5Z",
  fill: "#BFBBCF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49984 8.83333C1.0396 8.83333 0.666504 9.20643 0.666504 9.66667C0.666504 10.1269 1.0396 10.5 1.49984 10.5H16.4998C16.9601 10.5 17.3332 10.1269 17.3332 9.66667C17.3332 9.20643 16.9601 8.83333 16.4998 8.83333H1.49984Z",
  fill: "#BFBBCF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1665 13C7.70627 13 7.33317 13.3731 7.33317 13.8333C7.33317 14.2936 7.70627 14.6667 8.1665 14.6667H16.4998C16.9601 14.6667 17.3332 14.2936 17.3332 13.8333C17.3332 13.3731 16.9601 13 16.4998 13H8.1665Z",
  fill: "#BFBBCF"
});

function SvgIconAlignRightAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignRightAlt);
export default __webpack_public_path__ + "static/media/icon-align-right-alt.677194d4.svg";
export { ForwardRef as ReactComponent };